import { render, staticRenderFns } from "./RendPerformanceBuySell.vue?vue&type=template&id=20c19b5f&"
import script from "./RendPerformanceBuySell.vue?vue&type=script&lang=js&"
export * from "./RendPerformanceBuySell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports